import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  DateField,
  DateInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  required,
} from 'react-admin';

export const ReportList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField source="coin_id" reference="coins" label="Coin">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="title" />
      <TextField source="author" />
      <DateField source="date" />
    </Datagrid>
  </List>
);

export const ReportEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <ReferenceInput source="coin_id" reference="coins">
        <SelectInput optionText="name" validate={required()} />
      </ReferenceInput>
      <TextInput source="title" validate={required()} fullWidth />
      <TextInput source="author" fullWidth />
      <TextInput source="url" fullWidth />
      <DateInput source="date" />
      <TextInput source="body" multiline rows={10} fullWidth />
    </SimpleForm>
  </Edit>
);

export const ReportCreate = () => (
  <Create>
    <SimpleForm>
      <ReferenceInput source="coin_id" reference="coins">
        <SelectInput optionText="name" validate={required()} />
      </ReferenceInput>
      <TextInput source="title" validate={required()} fullWidth />
      <TextInput source="author" fullWidth />
      <TextInput source="url" fullWidth />
      <DateInput source="date" />
      <TextInput source="body" multiline rows={10} fullWidth />
    </SimpleForm>
  </Create>
);

export const ReportShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <ReferenceField source="coin_id" reference="coins" label="Coin">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="title" />
      <TextField source="author" />
      <TextField source="url" />
      <DateField source="date" />
      <TextField source="body" />
    </SimpleShowLayout>
  </Show>
);
